import {Button, Tag, Toggle} from '@/components/atoms'
import {useSegmentsOperations} from '@/hooks/promotion/segments/useSegmentsOperations'
import {useState} from 'react'
import {SegmentModal} from '../SegmentModal/SegmentModal'
import {SegmentGroup} from './SegmentGroup'

const defaultModalState = {
  show: false,
  type: '',
  groupIndex: null,
  isExcluded: false,
}

export const SegmentSection = ({isToggleBtnDisable = false}) => {
  const {
    handleAllCustomersToggle,
    handleExcludeToggle,
    isAllCustomers,
    isExcludeEnabled,
    segmentConfiguration,
    handleAddGroup,
    handleSubmitSegments,
    handleDeleteGroup,
    handleRemove,
  } = useSegmentsOperations()

  const [segmentModalState, setSegmentModalState] = useState(defaultModalState)

  const handleSegmentSelection = (items, groupIndex = null) => {
    const type = items?.[0]?.id
    if (!type) {
      return
    }
    setSegmentModalState({
      show: true,
      type,
      groupIndex,
    })
  }

  const handleCloseSegmentModal = () => {
    setSegmentModalState(defaultModalState)
  }

  const includedSegmentGroups = segmentConfiguration?.includedSegments || []

  return (
    <div className="products-admin-segment-section-wrapper flex flex-col gap-6 rounded-lg bg-gray-850 p-6">
      <h3 className="text-lg font-semibold">Segments</h3>
      <Toggle
        updateValue={handleAllCustomersToggle}
        value={isAllCustomers}
        uiSchema={{size: 'small', label: 'All Customers'}}
        disabled={isToggleBtnDisable}
      />

      {!isAllCustomers && (
        <>
          {includedSegmentGroups.map((segmentGroup, index) => (
            <div key={`group-${index}`}>
              <SegmentGroup
                groupIndex={index}
                segmentGroup={segmentGroup}
                onSegmentSelection={items => handleSegmentSelection(items, index)}
                handleDeleteGroup={handleDeleteGroup}
                handleRemove={handleRemove}
              />
              <div className="my-4 border-b border-gray-600"></div>
            </div>
          ))}

          {includedSegmentGroups.length > 1 && (
            <div className="mb-4 flex flex-wrap items-center gap-3">
              {includedSegmentGroups.map((_, index) => (
                <div
                  key={`group-label-${index}`}
                  className="products-admin-segment-section-group-label flex items-center gap-3"
                >
                  <Tag text={`Group ${index + 1}`} color="blue" />
                  {index < includedSegmentGroups.length - 1 && (
                    <span className="text-sm font-medium text-white">OR</span>
                  )}
                </div>
              ))}
            </div>
          )}

          <Button
            handleButton={handleAddGroup}
            uiSchema={{variant: 'tertiary', title: 'Add Group', iconLeading: 'add_box', size: 'medium'}}
          />

          <div className="text-xs">
            <p className="mb-2 text-gray-50">Within one group, users must be in all segments to see the promotion.</p>
            <p className="text-gray-50">
              When there are multiple groups, users can be in either group to see the promotion.
            </p>
          </div>
        </>
      )}

      <div className="h-px bg-gray-600" />
      <Toggle
        isDark
        updateValue={handleExcludeToggle}
        value={isExcludeEnabled}
        uiSchema={{size: 'small', label: 'Exclude'}}
        disabled={isToggleBtnDisable}
      />
      {isExcludeEnabled && (
        <>
          <SegmentGroup
            groupIndex={null}
            segmentGroup={segmentConfiguration?.excludedSegment}
            onSegmentSelection={items => handleSegmentSelection(items, null)}
            handleDeleteGroup={handleDeleteGroup}
            handleRemove={handleRemove}
          />
        </>
      )}

      <SegmentModal
        key={`segment-modal-${segmentModalState.show}-${segmentModalState.type}-${segmentModalState.groupIndex}`} // Force remount when groupIndex changes
        show={segmentModalState.show}
        type={segmentModalState.type}
        groupIndex={segmentModalState.groupIndex}
        existingSelections={
          segmentModalState.groupIndex === null
            ? segmentConfiguration?.excludedSegment?.segments
            : segmentConfiguration?.includedSegments?.[segmentModalState.groupIndex]?.segments
        }
        onSubmit={handleSubmitSegments}
        onClose={handleCloseSegmentModal}
      />
    </div>
  )
}
